import useSWR from 'swr';
// api
import getQuoteFormSettings from '../../api/getQuoteFormSettings';

// calls api to get quoteSettings
const quoteFormSettingsFetcher = async (...args) => {
  return getQuoteFormSettings(...args);
};

// returns ticketSettings with loading state
const useQuoteFormSettings = () => {
  const quoteFormSettingsRequestKey = 'quoteSettings';

  const { data: quoteFormSettings, error: quoteFormSettingsError } = useSWR(
    quoteFormSettingsRequestKey,
    quoteFormSettingsFetcher
  );

  const isLoadingQuoteFormSettings = typeof quoteFormSettings === 'undefined';

  return {
    isLoadingQuoteFormSettings,
    quoteFormSettings,
    quoteFormSettingsError,
  };
};

export default useQuoteFormSettings;
